(async () => {
    const { Core } = await importModule('Core');

    const LS_FLAG      = 'wsProCustomer';
    const SS_SEEN      = 'wsLoginPromptSeen'; // sessionStorage — resets each visit
    const ATTR_DELAY   = 'display-delay';
    const ATTR_POSITION = 'popup-position';
    const ATTR_LOGIN   = 'login-url';
    const DEFAULT_POS  = 'center';

    customElements.define('ws-login-prompt', class extends Core {

        async render() {
            await customElements.whenDefined('modal-popup');
            this._initPopup();
        }

        _initPopup() {
            if (!localStorage.getItem(LS_FLAG)) return;
            if (sessionStorage.getItem(SS_SEEN)) return;

            sessionStorage.setItem(SS_SEEN, '1');
            setTimeout(() => this._triggerModal(), this.displayDelay);
        }

        _triggerModal() {
            const template = document.getElementById('wsLoginPrompt');
            if (!template) return;

            template.content.querySelector('[data-wslp-message]').textContent = this.getAttribute('copy-message') || '';
            template.content.querySelector('[data-wslp-accept]').textContent  = this.getAttribute('copy-accept') || '';
            template.content.querySelector('[data-wslp-dismiss]').textContent = this.getAttribute('copy-dismiss') || '';

            this.publish('modal:open', {
                target:       '#wsLoginPrompt',
                backdrop:     true,
                close:        false,
                animation:    'fade',
                transition:   400,
                unlockScreen: false,
                position:     this.popupPosition
            });

            setTimeout(() => this._bindButtons(), 150);
        }

        _bindButtons() {
            const acceptBtn  = document.querySelector('[data-wslp-accept]');
            const dismissBtn = document.querySelector('[data-wslp-dismiss]');

            acceptBtn?.addEventListener('click', () => {
                const base = this.getAttribute(ATTR_LOGIN) || '/account/login';
                const returnTo = window.location.pathname + window.location.search;
                window.location.href = base + '?return_to=' + encodeURIComponent(returnTo);
            });

            dismissBtn?.addEventListener('click', () => {
                this.publish('modal:close');
            });
        }

        get displayDelay() {
            return this.getAttribute(ATTR_DELAY) * 1000;
        }

        get popupPosition() {
            return window.innerWidth <= 992
                ? DEFAULT_POS
                : (this.getAttribute(ATTR_POSITION) || DEFAULT_POS);
        }
    });
})();
